var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Model } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import DataTable from '@/components/data-table/DataTable';
import { Group } from '@/models/Group';
import { GroupTypeEnum } from '@/models/GroupType';
import { fileToBase64, formatDate } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
import { Token } from '@/support/Token';
import { Guardian } from '@/models/Guardian';
import AddGuardianDialog from '@/views/Users/Student/Dialogs/AddGuardianDialog';
import { Group as GroupModel } from '@/models/Group';
import { UserRelationship } from '@/models/UserRelationship';
import Storage from '@/support/Storage';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import { excludeRoles } from '@/support/ExcludeRoles';
import { cloneDeep } from 'lodash';
import AuthSetMfa from '@/components/AuthSetMfa/AuthSetMfa.vue';
import { RolesEnum } from '@/items/Roles';
import ConfirmRemoveMfaDialog from '@/components/ConfirmRemoveMfaDialog/ConfirmRemoveMfaDialog.vue';
let Profile = class Profile extends Vue {
    constructor() {
        super(...arguments);
        this.isEditing = false;
        this.isEditingDob = false;
        this.formatDob = formatDate;
        this.isAddingGuardian = false;
        this.userDialogType = 'guardian';
        this.group = new GroupModel();
        this.selectedUser = null;
        this.selectedRelationship = null;
        this.selectedTag = null;
        this.isUserRedoingLevel = false;
        this.studentClone = new Student();
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
        this.RoleEnum = RolesEnum;
        // #region RemoveMFA
        this.isConfirmRemoveMfaDialogOpen = false;
        // #endregion
    }
    get canEditProfileFields() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'parnassys_status';
        });
        const status = setting && setting.value;
        switch (status) {
            case '1':
            case '2':
                return !(this.studentClone && this.studentClone.parnassys_id);
            default:
                return true;
        }
    }
    get tags() {
        const tags = [];
        if (this.$store.state.tags) {
            this.$store.state.tags.forEach((tag) => {
                tags.push({ text: tag.name, value: tag.id });
            });
        }
        return tags;
    }
    get tableOptionsGuardian() {
        return {
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.TRAINER, RolesEnum.ROOT]) ? '/guardians/{id}' : '',
                },
            ],
            actions: this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.TRAINER, RolesEnum.ROOT]) ? [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/guardians/{id}',
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, user) => {
                        this.selectedUser = user;
                        if (this.student.relationships) {
                            const relation = this.student.relationships.filter((relationship) => {
                                return relationship.user.id === user.id;
                            })[0];
                            this.selectedRelationship = new UserRelationship({ id: relation.id });
                            this.selectedRelationship.user(this.student.id);
                        }
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ] : [],
            filters: [],
            dropdown: [],
            model: new Guardian().filter('relationship', {
                type: 'guardian',
                user: this.student.id || '',
            }),
        };
    }
    get tableOptions() {
        return {
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT]) ? '/groups/{id}' : '',
                },
            ],
            actions: this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT]) ? [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/groups/{id}',
                },
            ] : [],
            model: new Group().filter({
                users: this.student ? [this.student.id] : null,
                types: [GroupTypeEnum.CLASS, GroupTypeEnum.FIXED, GroupTypeEnum.COACH, GroupTypeEnum.PARNASSYS],
            }),
        };
    }
    get dialogOptions() {
        const user = this.selectedUser;
        return {
            title: user.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t(`dialogOptions.item.${user.filters.role}`) }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.selectedRelationship) {
                            return;
                        }
                        this.selectedRelationship
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedRelationship = null;
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedUser = null;
                    },
                },
            },
        };
    }
    get canChangeAvatar() {
        if (this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.TRAINER, RolesEnum.ADMIN, RolesEnum.TEACHER])) {
            return true;
        }
        const schoolType = Storage.get('type');
        if (schoolType && (this.$store.state.Auth.hasRole([RolesEnum.STUDENT]) && schoolType.toLowerCase() === 'vo')) {
            return true;
        }
        return false;
    }
    get canSeeIcons() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.ROOT]);
    }
    get canLoginAs() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.detail.profile.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        // set selectedTag
        if (this.student && this.student.tags && this.student.tags.length) {
            this.selectedTag = this.student.tags[0].id;
        }
        this.studentClone = cloneDeep(this.student);
    }
    update() {
        this.isEditing = false;
        if (this.password.new.length === 0) {
            this.resetPassword();
        }
        else {
            this.student.password = this.password.new;
        }
        if (this.selectedTag) {
            this.student.tags = [this.selectedTag];
        }
        const payload = this.student.getPayload();
        if (payload.avatar) {
            delete payload.avatar;
        }
        this.student
            .include(['student', 'roles', 'token', 'tags', 'portfolio'])
            .update(payload)
            .then((student) => {
            this.resetPassword();
            this.updateCurrentUser(student);
            this.studentClone = student;
            this.$emit('update', student);
        })
            .catch((error) => ErrorHandler.network(error));
    }
    resetPassword() {
        delete this.student.password;
        delete this.student.current_password;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    setToken() {
        Token.set(this.student.token.bearer);
        const url = `${window.location.protocol}//${window.location.host}`;
        window.location.href = url;
    }
    reloadStudent(relationships) {
        let includes = [];
        if (this.exclude) {
            includes = ['student', 'roles', 'token'];
        }
        else {
            includes = ['student', 'roles', 'token', 'relationships'];
        }
        this.student
            .include(includes)
            .update({ relationships })
            .then((student) => {
            this.updateCurrentUser(student);
            this.studentClone = cloneDeep(student);
            this.$emit('update', student);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    updateCurrentUser(student) {
        if (student.id === this.$store.state.Auth.id) {
            this.$store.dispatch('userAuthenticated', student);
        }
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        this.file = event.target.files[0];
        fileToBase64(this.file).then((encodedFile) => {
            this.baseImage = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const userWithDataObjects = await new Student()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (userWithDataObjects) {
            this.baseImage = userWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
    }
    avatarChanged(imageUrl) {
        this.student
            .include(['student', 'roles', 'token'])
            .update({ avatar: imageUrl })
            .then((student) => {
            this.student.avatar = imageUrl;
            this.updateCurrentUser(student);
            this.studentClone = cloneDeep(student);
            this.$emit('closed', false);
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    authHasRole(roles) {
        // console.log('authHasRole', this.$store.state.Auth.hasRole([roles]));
        return this.$store.state.Auth.hasRole([roles]);
    }
    get canRemoveMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get removeMfaEnabled() {
        return !!this.student.has_mfa_token;
    }
    async removeMfa() {
        if (this.student) {
            const student = await this.student
                .update({ mfa_token: null })
                .catch((error) => {
                ErrorHandler.network(error);
                return null;
            });
            if (student) {
                this.$set(this.student, 'has_mfa_token', false);
                if (this.studentClone) {
                    this.$set(this.studentClone, 'has_mfa_token', false);
                }
            }
        }
        this.isConfirmRemoveMfaDialogOpen = false;
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Profile.prototype, "student", void 0);
__decorate([
    Model('guardian', { default: () => new Guardian() }),
    __metadata("design:type", typeof (_b = typeof Guardian !== "undefined" && Guardian) === "function" ? _b : Object)
], Profile.prototype, "guardian", void 0);
Profile = __decorate([
    Component({
        components: {
            DataTable,
            AddGuardianDialog,
            ImageInput,
            AuthSetMfa,
            ConfirmRemoveMfaDialog,
        },
    })
], Profile);
export default Profile;
